import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { setIntegrationMutatingFlag, setOpenShareUnshareIntegrationDialog } from "redux/actions/portal/integrationActionCreator";
import { deleteIntegration } from "redux/actions/portal/integrationActionCreator";
import { DeleteIntegrationDialog } from "cxfcomponents/Integrations/DeleteIntegrationDialog";
import { UpdateIntegrationDialog } from "cxfcomponents/Integrations/UpdateIntegrationDialog";
import { useIntegrationPermissions } from "hooks/useIntegrationPermissions";
import { useNavigate } from "react-router-dom";

export const IntegrationsMenu = ({ integration, setSelectedIntegration, setIsShareMode, isShareDisabled, isUnshareDisabled, sharedIntegrationAccessType }) => {
   const [showUpdateIntegrationDialog, setShowUpdateIntegrationDialog] = useState(false);
   const [showDeleteIntegrationDialog, setShowDeleteIntegrationDialog] = useState(false);
   const { integrationMutatingFlag } = useSelector((store) => store?.portal?.integrations);
   const [integrationsMenu, setIntegrationsMenu] = useState(null);
   const dispatch = useDispatch();
   const { user } = useAuth0();
   const navigate = useNavigate();

   const { canEdit, canDelete, canShare, canOpenMenu } = useIntegrationPermissions(integration, sharedIntegrationAccessType);

   const handleViewIntegration = () => {
      handleCloseIntegrationsMenu();
      navigate(`/integration/${integration.id}`);
   };

   const handleOpenIntegrationsMenu = (event) => {
      setIntegrationsMenu(event.currentTarget);
   };

   const handleCloseIntegrationsMenu = () => {
      setIntegrationsMenu(null);
      setShowDeleteIntegrationDialog(false);
      setShowUpdateIntegrationDialog(false);
   };

   const handleAcceptDeletion = () => {
      if (!user.stripeId || integrationMutatingFlag) return;

      try {
         handleCloseIntegrationsMenu();
         dispatch(setIntegrationMutatingFlag(true));
         dispatch(
            deleteIntegration({
               tenant_id: user.stripeId,
               integration_id: integration.id
            })
         );
      } catch (error) {
         toast.error("Failed to delete the integration");
      }
   };

   const handleShowShareIntegrationDialog = () => {
      setSelectedIntegration(integration);
      dispatch(setOpenShareUnshareIntegrationDialog(true));
      setIsShareMode(true);
      handleCloseIntegrationsMenu();
   };

   const handleShowUnshareIntegrationDialog = () => {
      setSelectedIntegration(integration);
      dispatch(setOpenShareUnshareIntegrationDialog(true));
      setIsShareMode(false);
      handleCloseIntegrationsMenu();
   };

   return (
      <>
         {canOpenMenu && (
            <Tooltip title="More Actions" placement="top">
               <Icon fontSize="default" onClick={handleOpenIntegrationsMenu} sx={{ cursor: "pointer" }}>
                  {"more_horiz_icon"}
               </Icon>
            </Tooltip>
         )}
         <Menu
            anchorEl={integrationsMenu}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={Boolean(integrationsMenu)}
            onClose={handleCloseIntegrationsMenu}
            keepMounted
         >
            {canEdit && <MenuItem onClick={handleViewIntegration}>View</MenuItem>}

            {canShare && (
               <MenuItem disabled={isShareDisabled} onClick={handleShowShareIntegrationDialog}>
                  Share
               </MenuItem>
            )}

            {canShare && (
               <MenuItem disabled={isUnshareDisabled} onClick={handleShowUnshareIntegrationDialog}>
                  Unshare
               </MenuItem>
            )}

            {canDelete && <MenuItem onClick={() => setShowDeleteIntegrationDialog(true)}>Delete</MenuItem>}
         </Menu>
         <UpdateIntegrationDialog open={showUpdateIntegrationDialog} onClose={handleCloseIntegrationsMenu} integration={integration} />
         <DeleteIntegrationDialog open={showDeleteIntegrationDialog} onAccept={handleAcceptDeletion} onClose={handleCloseIntegrationsMenu} integration={integration} />
      </>
   );
};
